import { AttributeEntityType } from 'src/app/shared/models/attributes/attributeEntityType';

// TODO: A better name would be nice. Metadata is terrible.
// The goal here is to provide a translation layer between the name of the attribute
// and what we call it in the UI. I'm looking at you "Tracked" vs "Seat" attributes.
export class AttributeEntityTypeMetadata {
  constructor(public entityType: AttributeEntityType, public name: string) {}

  get hasDescription(): boolean {
    return (
      this.entityType === AttributeEntityType.Person ||
      this.entityType === AttributeEntityType.Survey ||
      this.entityType === AttributeEntityType.Evaluation
    );
  }

  static all(): AttributeEntityTypeMetadata[] {
    return [
      new AttributeEntityTypeMetadata(AttributeEntityType.Person, 'Person'),
      new AttributeEntityTypeMetadata(AttributeEntityType.Team, 'Team'),
      new AttributeEntityTypeMetadata(AttributeEntityType.Seat, 'Tracked'),
      new AttributeEntityTypeMetadata(AttributeEntityType.Survey, 'Survey'),
      new AttributeEntityTypeMetadata(AttributeEntityType.Evaluation, 'Evaluation'),
    ];
  }

  static all_viewable(): AttributeEntityTypeMetadata[] {
    return [
      new AttributeEntityTypeMetadata(AttributeEntityType.Person, 'Person'),
      new AttributeEntityTypeMetadata(AttributeEntityType.Team, 'Team'),
      new AttributeEntityTypeMetadata(AttributeEntityType.Seat, 'Tracked'),
    ];
  }
  static all_viewable_for_subField(): AttributeEntityTypeMetadata[] {
    return [new AttributeEntityTypeMetadata(AttributeEntityType.Person, 'Person')];
  }
  static get(entityType: AttributeEntityType): AttributeEntityTypeMetadata {
    return AttributeEntityTypeMetadata.all().find((item) => item.entityType === entityType);
  }
}
